var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 22.08,
  viewBox: "0 0 26 22.08"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-heart",
  "data-name": "Icon feather-heart",
  d: "M24.472,6.265a6.639,6.639,0,0,0-7.53-1.012,5.772,5.772,0,0,0-1.4,1.012L14.323,7.428,13.106,6.265a6.675,6.675,0,0,0-1.584-1.1A6.781,6.781,0,0,0,7,4.7,6.089,6.089,0,0,0,4.173,6.265a5.846,5.846,0,0,0,0,8.535L5.39,15.963,14.323,24.5l8.933-8.535L24.472,14.8a5.845,5.845,0,0,0,0-8.535Z",
  transform: "translate(-1.323 -3.417)",
  fill: "#fff",
  stroke: "#f6222c",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));
export default __webpack_public_path__ + "static/media/heartblank.a1fec5ce.svg";
export { SvgComponent as ReactComponent };